// extracted by mini-css-extract-plugin
export default {"loading":"OVfFL2iTuDgsiOxYXfEc"};